//
import PropTypes from "prop-types"
import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups.js"

import {
    VoteResultAmendmentFilter,
    VoteResultBillFilter,
    VoteResultDateListNoFutureFilter,
    VoteResultDatePickerStartNoFutureFilter,
    VoteResultDatePickerEndNoFutureFilter,
    VoteResultPersonFilter,
    VoteResultPartyFilter,
    VoteResultTypeFilter,
    VoteResultVoteFilter,
    VoteResultVotedWithOrAgainstFilter,
    VoteResultQuestionFilter,
    VoteResultBillTitleFilter,
    VoteResultAmendmentTitlteFilter,
    VoteResultBillExistsFilter,
    VoteResultAmendmentExistsFilter,
} from "shared/search/containers/Filter/VoteResultFilters"

const defaultPropTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}

export const VoteResultPartyFilterGroup = (props) => genericFilterGroup(props)
VoteResultPartyFilterGroup.propTypes = defaultPropTypes
VoteResultPartyFilterGroup.defaultProps = {
    filters: [VoteResultPartyFilter],
    uniqueFilterGroupId: "voteResultPartyFilterGroup",
    displayLabel: "Party",
    helpText: "Filter by party affiliation",
}

export const VoteResultTypeFilterGroup = (props) => genericFilterGroup(props)
VoteResultTypeFilterGroup.propTypes = defaultPropTypes
VoteResultTypeFilterGroup.defaultProps = {
    filters: [VoteResultTypeFilter],
    uniqueFilterGroupId: "voteResultTypeFilterGroup",
    displayLabel: "Vote Result Type",
    helpText: "Filter by vote result type",
}

export const VoteResultReferenceFilterGroup = (props) => genericFilterGroup(props)
VoteResultReferenceFilterGroup.propTypes = defaultPropTypes
VoteResultReferenceFilterGroup.defaultProps = {
    filters: [
        VoteResultPersonFilter,
        VoteResultBillFilter,
        VoteResultAmendmentFilter,
        VoteResultBillExistsFilter,
        VoteResultAmendmentExistsFilter,
    ],
    uniqueFilterGroupId: "voteResultReferenceFilterGroup",
    displayLabel: "Referencing",
    helpText: "Filter votes by association with a specific bill or amendment",
}

export const VoteResultPartyStance = (props) => genericFilterGroup(props)
VoteResultPartyStance.propTypes = defaultPropTypes
VoteResultPartyStance.defaultProps = {
    filters: [VoteResultVotedWithOrAgainstFilter],
    uniqueFilterGroupId: "voteResultPartyStanceFilterGroup",
    displayLabel: "Party Stance",
    helpText: "Filter votes by whether or not the Official voted along party lines",
}

export const VoteResultSearchFilterGroup = (props) => genericFilterGroup(props)
VoteResultSearchFilterGroup.propTypes = defaultPropTypes
VoteResultSearchFilterGroup.defaultProps = {
    filters: [
        VoteResultVoteFilter,
        VoteResultBillTitleFilter,
        VoteResultAmendmentTitlteFilter,
        VoteResultQuestionFilter,
    ],
    uniqueFilterGroupId: "voteResultSearchFilterGroup",
    displayLabel: "Votes",
    helpText: "Search for regulations by their title or description",
}

export const VoteResultDateFilterGroup = (props) => genericFilterGroup(props)
VoteResultDateFilterGroup.propTypes = defaultPropTypes
VoteResultDateFilterGroup.defaultProps = {
    filters: [
        VoteResultDateListNoFutureFilter,
        VoteResultDatePickerStartNoFutureFilter,
        VoteResultDatePickerEndNoFutureFilter,
    ],
    uniqueFilterGroupId: "voteResultDateFilterGroup",
    displayLabel: "Date",
    helpText: "Filter for Votes by date",
}
